// Admin preview only: an image whose original is too small for its place carries data-size-warning with the text (see
// components/media/image.html.twig, the rule in ImageTwigExtension::neededWidth()). It gets a dashed outline and
// a badge in its upper left corner, so the editor sees it before publishing. The badge is placed next to the <picture> in
// the image's own box, not in a layer above the page, so it moves along with sliders.
const SELECTOR = 'img[data-size-warning]';
const GAP = 8;

function place(img, badge) {
    const box = badge.parentElement;
    // the slider may have replaced the slide (loop clones) or the badge was removed
    if (!box || !img.isConnected) {
        return;
    }
    const image = img.getBoundingClientRect();
    badge.hidden = image.width === 0 || image.height === 0;
    if (badge.hidden) {
        return;
    }
    const parent = box.getBoundingClientRect();
    badge.style.top = `${image.top - parent.top - box.clientTop + GAP}px`;
    badge.style.left = `${image.left - parent.left - box.clientLeft + GAP}px`;
    badge.style.maxWidth = `${Math.max(image.width - 2 * GAP, 140)}px`;
}

export default function initSizeWarnings() {
    const images = [...document.querySelectorAll(SELECTOR)];
    if (!images.length) {
        return;
    }

    const pairs = images.map((img) => {
        const anchor = img.closest('picture') ?? img;
        const box = anchor.parentElement;
        if (getComputedStyle(box).position === 'static') {
            box.style.position = 'relative';
        }
        const badge = document.createElement('span');
        badge.className = 'size-warning';
        badge.setAttribute('role', 'note');
        badge.innerHTML = '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ';
        badge.append(img.dataset.sizeWarning);
        anchor.after(badge);
        return [img, badge];
    });

    const update = () => pairs.forEach(([img, badge]) => place(img, badge));
    update();
    window.addEventListener('load', update);
    window.addEventListener('resize', update);
    // images that load late, reveal effects and sliders change the boxes after the first placement
    const observer = new ResizeObserver(update);
    images.forEach((img) => observer.observe(img));
    document.querySelectorAll('.swiper').forEach((swiper) => swiper.addEventListener('transitionend', update));
}
